import { useEffect, useState } from 'react'
import { medusaClient } from 'web/src/lib/config'
import { Product } from '@medusajs/medusa'
import { useStore } from 'web/src/lib/context/store-context'

interface ReturnType {
    isSearchingProducts: boolean
    results: Product[] | null
}

/**
 * A simple abstraction to play with a boolean, don't repeat yourself.
 */
export const useSearch = (param: string, model?: string): ReturnType => {
    const carModel = model
    const { isSearchingProducts, setIsSearchingProducts } = useStore()
    const [results, setResults] = useState<Product[] | null>(null)

    const searchProducts = async () => {
        setIsSearchingProducts(true)
        await medusaClient.products
            .search({
                q: param,
                filter: 'status = published',
            })
            .then(({ hits }) => {
                setIsSearchingProducts(false)
                setResults(hits as Product[])
            })
            .catch(() => {
                setIsSearchingProducts(false)
                setResults(null)
            })
    }

    useEffect(() => {
        if (!results) {
            searchProducts()
        }
    }, [results])

    return {
        isSearchingProducts: isSearchingProducts,
        results: results,
    }
}
